import { render, staticRenderFns } from "./bar-graph.vue?vue&type=template&id=27e51f57&scoped=true&"
import script from "./bar-graph.vue?vue&type=script&lang=ts&"
export * from "./bar-graph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e51f57",
  null
  
)

export default component.exports